// extracted by mini-css-extract-plugin
export default {"orderingCont":"Ordering_orderingCont__pvf+V","orderingSelect":"Ordering_orderingSelect__EqRfU","orderingOption":"Ordering_orderingOption__C3waF"};